module.exports = __webpack_public_path__ + "media/images/ui__warning--dark-fa336ca15a82a2e63c5bdc3d79b2d177.png";